import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../../core/utils/utils.service';
import {Subject, Subscription} from 'rxjs';
import {StocksService} from "../../../core/services/gestion-stock/stocks.service";
import {StockAlerteSite} from "../../../core/models/gestion-stock/stock-alerte-site.model";
import {StockAlerte} from "../../../core/models/gestion-stock/stock-alerte.model";
import {BesoinsService} from "../../../core/services/gestion-commandes/besoins.service";
import {CatalogueAchatDTO} from "../../../core/dtos/catalogue-achat-dto";
import {ProduitDeclinaisonDTO} from "../../../core/dtos/produit-declinaison-dto";
import {ProduitArticleDTO} from "../../../core/dtos/produit-article-dto";
import {CommandesService} from "../../../core/services/gestion-commandes/commandes.service";
import {CommandeFournisseurQuantityDenreeModel} from "../../../core/models/gestion-commande-fournisseur/commande-fournisseur-quantity-denree.model";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {debounceTime} from "rxjs/internal/operators";
import {DxDataGridComponent} from "devextreme-angular";
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-stock-minimum',
  templateUrl: './stock-minimum.component.html',
  styleUrls: ['./stock-minimum.component.scss'],
  standalone: false
})
export class StockMinimumComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  private defaultList: StockAlerte[] = [];

  private subSiteStockMiniList: Subscription;
  private subStockAlerteList: Subscription;
  private subUpdateStockAlerte: Subscription;
  private subDeleteStockAlerte: Subscription;
  siteStockMiniList: StockAlerteSite[] = []
  selectedSite: number;
  stockAlerteList: StockAlerte[] = [];
  selectedStockAlerteList: number[] = [];
  selectedStockAlerteDisplayOrders: StockAlerte;
  orders: CommandeFournisseurQuantityDenreeModel[] = [];
  private subGetOrdersByStockAlerte: Subscription;

  subGlobalSearch: Subscription;
  subjectGlobalSearch: Subject<string> = new Subject<string>();
  globalSearch$ = this.subjectGlobalSearch.asObservable();

  globalFilterWrote: string;
  @ViewChild('grid') grid: DxDataGridComponent;

  constructor(
    public utils: UtilsService,
    private readonly stockSvc: StocksService,
    private readonly besoinSvc: BesoinsService,
    private readonly commandesSvc: CommandesService) {
  }


  ngOnInit() {
    this.subscriptionGlobalFilterSearch();

    this.subSiteStockMiniList = this.stockSvc.getSiteStockMini().subscribe(res => {
      this.siteStockMiniList = res.resultList;
      if (this.siteStockMiniList.length > 0)
        this.selectedSite = this.siteStockMiniList[0].idSite;
    });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subSiteStockMiniList);
    this.utils.unsubscribe(this.subStockAlerteList);
    this.utils.unsubscribe(this.subUpdateStockAlerte);
    this.utils.unsubscribe(this.subDeleteStockAlerte);
    this.utils.unsubscribe(this.subGetOrdersByStockAlerte);
    this.utils.unsubscribe(this.subGlobalSearch);
  }

  refreshAlertes() {
    this.subUpdateStockAlerte = this.stockSvc.updateStockAlerte(this.selectedSite).subscribe({
      complete: () => {
        this.iniSiteStockMiniList();
        this.updateStockAlerteQuantity();
        this.initStockAlertList();
      }
    });
  };

  initStockAlertList() {
    this.subStockAlerteList = this.stockSvc.getStockAlerteBySite(this.selectedSite).subscribe(res => {
      this.stockAlerteList = res.resultList;
      this.defaultList = res.resultList; //Copy of the default list for global filter reset
    });
  };

  convertToOrder() {
    const alerteListToOrder: StockAlerte[] = this.selectedStockAlerteList.length > 0 ? this.stockAlerteList.filter(alerte => this.selectedStockAlerteList.includes(alerte.id)) : this.stockAlerteList;
    this.deleteStockAlerte(alerteListToOrder.map(item => item.id))
    const catalogueAchatList: CatalogueAchatDTO[] = alerteListToOrder.map((item: StockAlerte) => {
      const catalogueAchat: CatalogueAchatDTO = new CatalogueAchatDTO();
      const produitDeclinaison: ProduitDeclinaisonDTO = new ProduitDeclinaisonDTO();
      produitDeclinaison.id = item.produitDeclinaisonId;
      catalogueAchat.produitDeclinaison = produitDeclinaison
      catalogueAchat.produitArticle = new ProduitArticleDTO();
      catalogueAchat.produitArticle.produitDeclinaison = produitDeclinaison;
      catalogueAchat.idUniteProduction = this.selectedSite;
      catalogueAchat.quantite = item.quantite;
      catalogueAchat.site = new SiteDTO();
      catalogueAchat.site.id = this.selectedSite;
      return catalogueAchat;
    });
    this.besoinSvc.announceOpenPropositionDialogDenree(catalogueAchatList);
  }

  deleteStockAlerte(idsToDelete: number[]) {
    this.subDeleteStockAlerte = this.stockSvc.deleteStockAlerte(idsToDelete).subscribe({
      complete: () => {
        this.stockAlerteList = this.stockAlerteList.filter(item => !idsToDelete.includes(item.id));
        this.iniSiteStockMiniList();
        this.updateStockAlerteQuantity();
      }
    });
  }

  private iniSiteStockMiniList = () => {
    this.subSiteStockMiniList = this.stockSvc.getSiteStockMini().subscribe(res => {
      this.siteStockMiniList = res.resultList;
    });
  };

  private updateStockAlerteQuantity = () => {
    this.stockSvc.announceUpdateStockAlertQuantity();
  };

  changeSelectedAlerte(stockAlerte: StockAlerte) {
    this.orders = [];
    this.selectedStockAlerteDisplayOrders = stockAlerte
    this.subGetOrdersByStockAlerte = this.commandesSvc.findBonCfCommandesAReceptionner(stockAlerte.produitDeclinaisonId, this.selectedSite).subscribe(res => {
      this.orders = res.resultList;
    });
  }

  announceGlobalFilterSearch = (e: any): void => {
    this.subjectGlobalSearch.next(e.value);
  }

  subscriptionGlobalFilterSearch = (): void => {
    this.subGlobalSearch = this.globalSearch$
      .pipe(debounceTime(500))
      .subscribe(searchValue => {
        this.globalFilterWrote = searchValue;
        if (this.globalFilterWrote && this.globalFilterWrote.trim() !== '') {
          const filterValue = this.globalFilterWrote.trim().toLowerCase();
          this.stockAlerteList = this.defaultList.filter(alerte => {
            return Object.keys(alerte).some(key => {
              if (key !== 'id' && key !== 'produitDeclinaisonId') {
                const value = alerte[key as keyof StockAlerte];
                if (value !== null && value !== undefined) {
                  return value.toString().toLowerCase().includes(filterValue);
                }
              }
            });
          });
        }
        else {
          this.stockAlerteList = this.defaultList;
        }

        this.grid.instance.refresh();
      });
  }
}
